import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddCampaignPopup from "./AddCampaignPopup";
import { Campaign } from "api/Campaigns/CampaignInterfaces";

interface CampaignEmptyPageProps {
  onCampaignCreated?: (newCampaign: Campaign) => void;
}

export default function CampaignEmptyPage({ onCampaignCreated }: CampaignEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Campaigns"
      colorKey="campaigns"
      AddPopupComponent={AddCampaignPopup}
      onEntityCreated={onCampaignCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select a Campaign",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Campaign",
          openPopup: true,
        },
        {
          id: "details",
          type: "text",
          text: "View Details of a Campaign",
          direction: "down",
        },
      ]}
    />
  );
}
